var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2786 1.30204C10.3942 4.45101 14.3588 7.01557 17.274 8.5308L17.2736 9.93036C14.3574 11.2142 10.5078 13.6647 10.5068 16.6971L8.40746 16.6978C8.29194 13.3156 11.7916 10.9818 14.2411 10.1646L1.17862 9.93565L1.17931 7.83631L14.2418 8.06528C11.6762 7.36634 8.06152 4.68504 8.17926 1.30273L10.2786 1.30204Z",
    fill: "#171C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDark);
export default __webpack_public_path__ + "static/media/arrow-right-dark.1a1015d3c40a519f9ff09b3d06378cff.svg";
export { ForwardRef as ReactComponent };